import { PostFormState } from "../../../shared/types/post";
import { Dispatch } from "redux";
import { updatePostFormField } from "../../../actions/postForm";

export const shouldLazyLoadForm = (formCount: number): boolean => {
  // Lazy load if more than 5 forms open
  return formCount > 5;
};

export const initializeFormHeavyResources = (
  form: PostFormState,
  dispatch: Dispatch
): void => {
  if (form.isInitialized) {
    return; // Already initialized
  }

  // Mark as initialized
  dispatch(updatePostFormField(form.post._id, { isInitialized: true }));

  // Pre-load media thumbnails
  if (form.post.mediaFiles?.length) {
    const firstMedia = form.post.mediaFiles[0];
    if (firstMedia.thumbnailUrl) {
      const img = new Image();
      img.onload = () => {
        console.log(
          `[LazyInit] Thumbnail pre-loaded for form ${form.post._id}`
        );
      };
      img.onerror = (error) => {
        console.warn(
          `[LazyInit] Failed to pre-load thumbnail for form ${form.post._id}:`,
          firstMedia.thumbnailUrl,
          error
        );
      };
      img.src = firstMedia.thumbnailUrl;
    }
  }

  console.log(`[LazyInit] Form ${form.post._id} initialized`);
};
